import React, { useEffect } from 'react';
import './Mothercare.css';
import usePageTitle from '../hooks/usePageTitle';
import borderImage from '../assets/border.png';
import mothercare1 from '../assets/mothercare1.png';
import mothercare2 from '../assets/mothercare2.png';

const Mothercare: React.FC = () => {
  usePageTitle('Mothercare');
  
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Remove animation classes first to reset
    const allElements = document.querySelectorAll('.mothercare-title, .mothercare-subtitle, .mothercare-description, .mothercare-paragraph');
    allElements.forEach(element => {
      element.classList.remove('animate-in-initial');
    });
    
    // Force reflow to ensure the removal is processed
    void document.body.offsetHeight;
    
    // Animate initial content on page load
    const titleElement = document.querySelector('.mothercare-title');
    if (titleElement) {
      setTimeout(() => {
        titleElement.classList.add('animate-in-initial');
      }, 200);
    }
    
    // Subtitle animates after title
    const subtitleElements = document.querySelectorAll('.mothercare-subtitle');
    setTimeout(() => {
      subtitleElements.forEach(element => {
        element.classList.add('animate-in-initial');
      });
    }, 210);
    
    // Paragraphs animate 200ms after subtitle
    const paragraphElements = document.querySelectorAll('.mothercare-description, .mothercare-paragraph');
    setTimeout(() => {
      paragraphElements.forEach(element => {
        element.classList.add('animate-in-initial');
      });
    }, 410);
  }, []);

  return (
    <div className="mothercare-page">
      <div className="mothercare-container">
        <h1 className="mothercare-title">Mothercare Counseling</h1>
        <h2 className="mothercare-subtitle">AI-Powered Platform for Maternal Support</h2>
        <img src={borderImage} alt="" className="mothercare-border-image" />
        
        <div className="mothercare-content">
          <div className="mothercare-images-section">
            <div className="mothercare-images-container">
              <img src={mothercare2} alt="Mothercare Service Features" className="mothercare-image mothercare-image-left" />
              <img src={mothercare1} alt="Mothercare Platform Interface" className="mothercare-image mothercare-image-right" />
            </div>
          </div>
          
          <div className="mothercare-decorative-line"></div>
          
          <div className="mothercare-text">
            <p className="mothercare-description">
              An intelligent assistance platform harnessing technology to bridge the gap between vulnerable populations 
              and essential services. Through sophisticated natural language processing, the system provides personalized 
              legal counsel and welfare navigation while coordinating comprehensive data analysis to identify systemic 
              barriers facing single-parent households.
            </p>
            
            <p className="mothercare-paragraph">
              Gender Studies & Policy | Admission to Cornell
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mothercare;